import ProductsConfig from './ProductsConfig';

export default ProductsConfig;
